import Button from '../components/common/Button';
import SectionHeading from '../components/common/SectionHeading';

function NotFound() {
  return (
    <section className="page-section">
      <div className="container">
        <SectionHeading eyebrow="404" title="Page not found" text="The page you requested does not exist." />
        <Button to="/">Return Home</Button>
      </div>
    </section>
  );
}

export default NotFound;
